import React from 'react';
import { useDealByIdQuery } from 'api';
import { Attachments } from 'components';
import { MicroserviceTypes } from 'typings';
import { useParams } from 'react-router-dom';
import { PERMISSIONS } from 'constants/permissions';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const DealAttachments: React.FC = () => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  const { data: { isFinalStatus } = {} } = useDealByIdQuery({ id }, { skip: !id });
  return (
    <Attachments
      entityId={id}
      entityName={'DEAL'}
      service={'wrd' as MicroserviceTypes}
      hasAccessToWrite={hasAccess(PERMISSIONS.deals.attachment.write) && !isFinalStatus}
      hasAccessToDelete={hasAccess(PERMISSIONS.deals.attachment.delete) && !isFinalStatus}
    />
  );
};
